// list-publishers.js
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import api from '../../services/api';
import { getUserType, logout } from "../../services/auth";
import Header from '../../components/header';
import TitlePage from '../../components/title-page';
import Search from '../../components/search';

export default class ListProjects extends Component {
  state = {
    redirect: false,
    notAdmin: false,
    user_type: "",
    allCompanies: [],
    company_list: [],
    loading: true,
    error: null,
    view: 50,
    page: 1,
    currentPos: 0,
    viewing: "0-0",
    totalCompanies: 0,
    totalPages: 1,
    order: "First",
    search: "",
  };

  componentDidMount() {
    const userType = getUserType();
    if (userType !== "admin") {
      this.setState({ notAdmin: true });
      return;
    }
    this.setState({ user_type: userType }, () => this.fetchAndPrepareCompanies());
  }

  fetchAndPrepareCompanies = async () => {
    this.setState({ loading: true, error: null });
    try {
      const response = await api.get(`app_users?filter[include]=companies`);
      const users = Array.isArray(response.data) ? response.data : [];
      const tmp = [];

      users.forEach(user => {
        if (user && user.active && Array.isArray(user.companies)) {
          user.companies.forEach(comp => {
            if (comp && comp.id != null && comp.name) tmp.push(comp);
          });
        }
      });

      const uniqueById = {};
      const uniqueList = [];
      tmp.forEach(comp => {
        const id = String(comp.id);
        if (!uniqueById[id]) {
          uniqueById[id] = true;
          uniqueList.push(comp);
        }
      });

      this.setState({ allCompanies: uniqueList }, () => {
        this.updatePaginationAndList(1, this.state.view, this.state.order, this.state.search);
      });
    } catch (error) {
      console.error("fetchAndPrepareCompanies error:", error);
      if (String(error).includes("status code 401")) {
        logout();
        setTimeout(() => this.setState({ redirect: true }), 600);
      } else {
        this.setState({ loading: false, error });
      }
    }
  };

  sortCompanies = (list, order) => {
    const copy = [...list];
    if (order === "First") copy.sort((a, b) => Number(a.id) - Number(b.id));
    else if (order === "Latest") copy.sort((a, b) => Number(b.id) - Number(a.id));
    else if (order === "A-Z") copy.sort((a, b) => a.name.localeCompare(b.name));
    else if (order === "Z-A") copy.sort((a, b) => b.name.localeCompare(a.name));
    return copy;
  };

  updatePaginationAndList = (page = 1, view = 50, order = "First", search = "") => {
    const all = this.state.allCompanies || [];
    let filtered = all;
    const raw = (search || "").trim();
    if (raw.length >= 2) {
      const term = raw.toLowerCase();
      filtered = all.filter(c => c.name.toLowerCase().includes(term));
    }

    const ordered = this.sortCompanies(filtered, order);
    const total = ordered.length;
    const totalPages = Math.max(1, Math.ceil(total / view));
    const clampedPage = Math.min(Math.max(1, page), totalPages);
    const start = (clampedPage - 1) * view;
    const end = start + view;
    const pageSlice = ordered.slice(start, end);
    const viewing = total === 0 ? "0-0" : `${start + 1}-${Math.min(end, total)}`;

    this.setState({
      company_list: pageSlice,
      totalCompanies: total,
      totalPages,
      page: clampedPage,
      view,
      currentPos: start,
      viewing,
      order,
      loading: false,
      search,
    });
  };

  changeOrder = (order) => this.updatePaginationAndList(1, this.state.view, order, this.state.search);
  changeView = (view) => this.updatePaginationAndList(1, view, this.state.order, this.state.search);
  goToPage = (page) => this.updatePaginationAndList(page, this.state.view, this.state.order, this.state.search);

  handleSearchSubmit = (e) => {
    e && e.preventDefault();
    const raw = (this.state.search || "").trim();
    if (!raw || raw.length < 2) {
      this.updatePaginationAndList(1, this.state.view, this.state.order, "");
      return;
    }
    this.updatePaginationAndList(1, this.state.view, this.state.order, raw);
  };

  viewProjectsForCompany = (company) => {
    localStorage.setItem("company_selected", company.id);
    localStorage.setItem("company_selected_name", company.name);
    if (this.props.history && this.props.history.push) {
      this.props.history.push('/projects');
    } else {
      window.location.href = '/projects';
    }
  };

  renderPaginationButtons = () => {
    const { totalPages, page } = this.state;
    const pages = [];
    const start = Math.max(1, page - 2);
    const end = Math.min(totalPages, start + 4);
    for (let p = start; p <= end; p++) pages.push(p);

    return (
      <div data-component="pagination" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button className="link" disabled={page === 1} onClick={() => this.goToPage(1)}>First</button>
        {pages.map(p => (
          <button key={p} className={`link ${p === page ? 'active' : ''}`} onClick={() => this.goToPage(p)}>{p}</button>
        ))}
        <button className="link" disabled={page === totalPages} onClick={() => this.goToPage(totalPages)}>Last</button>
      </div>
    );
  };

  render() {
    if (this.state.notAdmin) return <Redirect to='/projects' />;
    if (this.state.redirect) return <Redirect to='/Login' />;

    const { company_list, loading, error, view, viewing, totalCompanies, order, search } = this.state;

    return (
      <div data-page="list-publishers">
        <Header />
        <TitlePage title="Companies" />

        <div className="container-fluid" data-component="page-list-content">
          <div className="container">

            {/* Header de filtros y búsqueda */}
            <div data-component="content-list-header">
              <div className="row" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div className="actions" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                 
                  <div data-component="dropdown">
                    <p className="dropdown-text"> Order: {order} </p>
                    <div className="dropdown-submenu">
                      <button className="link" onClick={() => this.changeOrder("First")}>View First Records</button>
                      <button className="link" onClick={() => this.changeOrder("Latest")}>View Latest Records</button>
                      <button className="link" onClick={() => this.changeOrder("A-Z")}>View A-Z</button>
                      <button className="link" onClick={() => this.changeOrder("Z-A")}>View Z-A</button>
                    </div>
                  </div>

                  <div data-component="dropdown">
                    <p className="dropdown-text"> Viewing: {view} </p>
                    <div className="dropdown-submenu">
                      {[10, 20, 50, 100, 500].map(num => (
                        <button key={num} className="link" onClick={() => this.changeView(num)}>View {num}</button>
                      ))}
                    </div>
                  </div>

                  <p className="text">Displaying {viewing} of {totalCompanies}</p>
                </div>

                <div className="search" style={{ marginLeft: 'auto' }}>
                  <Search
                    onSubmit={this.handleSearchSubmit}
                    placeholder="Search companies (min 2 chars)"
                    value={search}
                    onChange={e => this.setState({ search: e.target.value })}
                  />
                </div>
              </div>
            </div>

            {/* Tabla */}
            <div data-component="content-list-body" style={{ marginTop: 12 }}>
              <div className="list-body-header" style={{ display: 'flex', padding: '10px 8px', borderBottom: '2px solid #ccc' }}>
                <div style={{ flex: '4 1 80%', textAlign: 'left' }}>
                  <strong className="body-title">Name</strong>
                </div>
                <div style={{ flex: '1 1 20%', textAlign: 'right' }}>
                  <strong className="body-title">Action</strong>
                </div>
              </div>

              <div className="list-body-content">
                {loading ? (
                  
                  <div data-component="loader">
                    <div className="loader-pulse-content">
                      
                    </div>
                  </div>
                ) : error ? (
                  <p>Error loading companies.</p>
                ) : company_list.length === 0 ? (
                  <p>No Companies Found.</p>
                ) : (
                  company_list.map(company => (
                    <div className="list-item"
                      key={company.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '10px 8px',
                        borderBottom: '1px solid #eee'
                      }}
                    >
                      <div style={{ flex: '4 1 80%', textAlign: 'left' }}>
                        <p className="body-text name" style={{ margin: 0 }}>{company.name}</p>
                      </div>
                      <div style={{ flex: '1 1 20%', textAlign: 'right' }}>
                        <button className="btn" onClick={() => this.viewProjectsForCompany(company)}>Projects</button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* Footer de paginación */}
            <div data-component="content-list-footer" style={{ marginTop: 12 }}>
              {this.renderPaginationButtons()}
            </div>

          </div>
        </div>
      </div>
    );
  }
}
